/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import { OfficeMeasurement } from '../models/office-measurement.enum';
import { OfficeStatus } from '../models/office-status.enum';
import { OfficeType } from '../models/office-type.enum';
import { OfficeDto } from '../models/office.dto';

export const OfficeMapper = entity<OfficeDto>({
  type: enumeration(OfficeType),
  status: enumeration(OfficeStatus),
  measurementScale: enumeration(OfficeMeasurement),
});
